import { ContactsCustomListItem } from '@src/app/modules/contacts-directory';

import { EditCommitteeContact, ContactWithCustomListIds } from '../api';

import { TuiFileLikeUI } from './document.model';

export interface ContactUI extends EditCommitteeContact, ContactWithCustomListIds {
  newDocument?: File;
  oldDocument?: TuiFileLikeUI;
  value?: string;
  contactListValues?: ContactsCustomListItem[];
}
